<template>
  <label
    :class="{
      'ph-checkbox': true,
      'is-checked': checked
    }"
  >
    <span class="ph-checkbox__input">
      <span
        :class="{
          'ph-checkbox__inner': true,
          'is-checked': checked
        }"
      />
      <input
        type="checkbox"
        class="ph-checkbox__original"
        @change="onChange"
      />
    </span>
    <span class="ph-checkbox__label">
      <slot></slot>
    </span>
  </label>
</template>
<script>
export default {
  name: 'PhCheckbox',
  props: {
    value: {
      type: Boolean,
      required: false
    }
  },
  data() {
    return {
      checked: false
    }
  },
  watch: {
    value: {
      handler(val) {
        this.checked = val;
      },
      immediate: true
    }
  },
  methods: {
    onChange() {
      this.checked = !this.checked;
      this.$emit('input', this.checked);
    }
  }
};
</script>
